var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9907 1.9989C11.4387 1.9989 10.9907 2.4466 10.9907 2.9989V12.9989H7.99072L11.9907 16.9989L15.9907 12.9989H12.9907V2.9989C12.9907 2.4466 12.5427 1.9988 11.9907 1.9989ZM3.99072 13.9989C3.43842 13.9989 2.99072 14.4469 2.99072 14.9989V16.9989C2.99072 19.2079 4.78162 20.9989 6.99072 20.9989H16.9907C19.1997 20.9989 20.9907 19.2079 20.9907 16.9989V14.9989C20.9907 14.4469 20.5427 13.9989 19.9907 13.9989C19.4387 13.9989 18.9907 14.4469 18.9907 14.9989V16.9989C18.9907 18.1039 18.0957 18.9989 16.9907 18.9989H6.99072C5.88612 18.9989 4.99072 18.1039 4.99072 16.9989V14.9989C4.99072 14.4469 4.54302 13.9989 3.99072 13.9989Z",
    fill: "#003056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.646057f3963e613c4bb812bca2fc6952.svg";
export { ForwardRef as ReactComponent };